import {
    Component,
    EventEmitter,
    Output,
    Type,
    ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { UserModel } from "src/app/shared/models/usuarios/user.model";
import { AppComponent } from "../app.component";
import { AuthenticationService } from "../login/authentication/authentication.service";
import { MenuService } from "../menu/app.menu.service";
import { SwitchApp } from "src/app/shared/models/enum/switchApp.model";
import { BehaviorSubject } from "rxjs";
import { ToastService } from "../services/toast/toast.service";
import { MenuItem } from "primeng/api";
import { ChatService } from "../services/chat.service";
import { TaxisService } from "../services/taxis.service";

@Component({
    selector: "app-main",
    templateUrl: "./app.main.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AppMainComponent {
    currentUser: UserModel;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    slimMenuActive: boolean;

    slimMenuAnchor = false;

    toggleMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    resetMenu: boolean;

    menuHoverActive: boolean;

    rightPanelActive: boolean;

    rightPanelClick: boolean;

    configActive: boolean;

    configClick: boolean;

    nopadd: boolean;

    serviceBackButtonVisible = true;

    volverDesdeServicio(): void {
        const isTaxis = this.app.switchApp?.value == SwitchApp.TAXIS;
        this.router.navigate([
            isTaxis ? "taxis/pendientes" : "conductores/listado-servicios",
        ]);
    }

    subjectBreadCumb: BehaviorSubject<string> = new BehaviorSubject(null);

    showHelper: boolean;

    constructor(
        private menuService: MenuService,
        public app: AppComponent,
        private router: Router,
        private authenticationService: AuthenticationService,
        private msg: ToastService,
        private chatService: ChatService,
        private taxisService: TaxisService
    ) {
        this.authenticationService.currentUser.subscribe(
            (x) => (this.currentUser = x)
        );
    }

    async logout() {
        this.chatService.stopChat();

        try {
            await this.taxisService.RemoveDatosGuardadosTaller().toPromise();
        } catch (error) {
            console.error("Error borrando datos Taller en logout:", error);
        }

        try {
            await this.taxisService.RemoveDatosGuardadosTrafico().toPromise();
        } catch (error) {
            console.error("Error borrando datos Tráfico en logout:", error);
        }

        this.authenticationService.logout();
        this.router.navigateByUrl("/login");
    }

    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.rightPanelClick) {
            this.rightPanelActive = false;
        }

        if (!this.menuClick) {
            if (this.isHorizontal()) {
                this.menuService.reset();
            }

            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }

            if (this.slimMenuActive) {
                this.hideSlimMenu();
            }

            if (this.toggleMenuActive) {
                this.hideToggleMenu();
            }

            this.menuHoverActive = false;
        }

        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }

        this.configClick = false;
        this.topbarItemClick = false;
        this.menuClick = false;
        this.rightPanelClick = false;
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.topbarMenuActive = false;

        if (this.isOverlay()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }
        if (this.isToggle()) {
            this.toggleMenuActive = !this.toggleMenuActive;
        }
        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
        this.resetMenu = false;
    }

    onAnchorClick(event) {
        if (this.isSlim()) {
            this.slimMenuAnchor = !this.slimMenuAnchor;
        }
        event.preventDefault();
    }

    onMenuMouseEnter(event) {
        if (this.isSlim()) {
            this.slimMenuActive = true;
        }
    }

    onMenuMouseLeave(event) {
        if (this.isSlim()) {
            this.slimMenuActive = false;
        }
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onRightPanelButtonClick(event) {
        this.rightPanelClick = true;
        this.rightPanelActive = !this.rightPanelActive;
        event.preventDefault();
    }

    onRightPanelClick() {
        this.rightPanelClick = true;
    }

    onRippleChange(event) {
        this.app.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    isHorizontal() {
        return this.app.menuMode === "horizontal";
    }

    isSlim() {
        return this.app.menuMode === "slim";
    }

    isOverlay() {
        return this.app.menuMode === "overlay";
    }

    isToggle() {
        return this.app.menuMode === "toggle";
    }

    isStatic() {
        return this.app.menuMode === "static";
    }

    isMobile() {
        return window.innerWidth < 1281;
    }

    isDesktop() {
        return window.innerWidth > 1280;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1280 && width > 640;
    }

    isMobileRegulares() {
        return window.innerWidth < 640;
    }

    hideOverlayMenu() {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    hideSlimMenu() {
        this.slimMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    hideToggleMenu() {
        this.toggleMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    @Output()
    onClickEvent: EventEmitter<any> = new EventEmitter();

    onClickHelp() {
        this.onClickEvent.emit();
    }

    showHelp(componentType: Type<any>, tipo: string, items: MenuItem[]) {
        this.msg.open(componentType, {
            header: `Guía ${tipo}`,
            width: "100%",
            height: "100%",
            styleClass: "max-h-screen",
            closable: true,
            data: {
                items: items,
            },
        });
    }
}
